import { render } from "./MediaflowMonitorHeader.vue?vue&type=template&id=50b80cfc"
import script from "./MediaflowMonitorHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowMonitorHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowMonitorHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50b80cfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50b80cfc', __exports__)) {
    api.reload('50b80cfc', __exports__)
  }
  
  module.hot.accept("./MediaflowMonitorHeader.vue?vue&type=template&id=50b80cfc", () => {
    api.rerender('50b80cfc', render)
  })

}


export default __exports__